module.exports = {
	"articleTitle1": "Lila Kalick: Finding a savory slice in Ann Arbor's sea of mediocre pizza",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Silvio's Organic Pizza",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/silvios-renovation-brings-expanded-seating-and-menu",
	"articleSnippet1": "Oct 21, 2009 ... Silvio's commitment to locally bought fresh ingredients and innovative flavor \ncombinations yields a superior slice — one that a surprisingly large ...",
	"articleSnippet2": "Feb 10, 2010 ... Silvio's Organic Pizza, a restaurant known for its healthy food and intimate \natmosphere, recently underwent renovations, decorating the space ...",
	"foodRecommendations": [
		{
			"text": "If you're looking for guilt free pizza, look no further than right here.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Silvio's renovation brings expanded seating and menu",
	"address": "715 N University Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.278915,
		"lng": -83.74002
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/silvios.json
// module id = 971
// module chunks = 0